import {get, post} from '~/utils/request';

export function getJobList(data) {
  return post('/Job/GetPostList', data);
}

export function jobEdit(data){
  return post('/Job/Edit', data);
}

export function getJobInfo(data){
  return post('/Job/JobInfo', data);
}

export function getJobSimpleInfo(data){
  return post('/Job/JobSimpleInfo', data);
}

export function online(data){
  return post('/Job/Online', data);
}

export function offline(data){
  return post('/Job/Offline', data);
}

export function refresh(data){
  return post('/Job/Refresh', data);
}

export function deleteJob(data){
  return post('/Job/Del', data);
}

//获取我正在招聘的职位列表（人事）
export function getMyNormalList(data){
  return post('/Job/GetMyNormalList', data);
}